import { defineMessages } from 'react-intl'

export default defineMessages({
  followUp: {
    id: 'visitRow.followUp',
    defaultMessage: 'FollowUp'
  },
  visit: {
    id: 'visitRow.visit',
    defaultMessage: 'Visit'
  }
})
